import { Modal, Button, Card, Row, Col } from 'react-bootstrap'
import { TEMPLATE_STARTERS, TemplateStarter } from '../../../constants/templateStarters'

type Props = {
    show: boolean
    onHide: () => void
    onSelect: (starter: TemplateStarter) => void
    onStartFromScratch: () => void
}

export const TemplateStarterModal = ({ show, onHide, onSelect, onStartFromScratch }: Props) => {
    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>Choose a Template Starter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-4">
                    Start with a professional template or create your own from scratch
                </p>

                <Row className="g-4 mb-4">
                    {TEMPLATE_STARTERS.map((starter) => (
                        <Col key={starter.id} md={4}>
                            <Card
                                className="h-100 template-starter-card"
                                style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                onClick={() => onSelect(starter)}
                            >
                                <Card.Body className="d-flex flex-column">
                                    <div className="text-center mb-3">
                                        <div style={{ fontSize: '48px' }}>{starter.icon}</div>
                                    </div>
                                    <Card.Title className="text-center mb-2">{starter.name}</Card.Title>
                                    <Card.Text className="text-muted text-center flex-grow-1" style={{ fontSize: '14px' }}>
                                        {starter.description}
                                    </Card.Text>
                                    <Button variant="primary" size="sm" className="mt-3">
                                        Use This Template
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <div className="text-center pt-3 border-top">
                    <Button variant="outline-secondary" onClick={onStartFromScratch}>
                        <i className="bi bi-file-earmark-plus me-2"></i>
                        Start from Scratch
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
